export default __webpack_public_path__ + "static/media/id-card-solid.43c93870.svg";